export default __webpack_public_path__ + "static/media/gallery-2.2f5ac9d4.png";